import _ from 'lodash';
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import ReactModal from 'react-modal';
import autobind from 'autobind-decorator';
import { NavLink } from 'react-router-dom';
import FieldFactory from 'common/components/field-factory';

// import EditImage from 'common/components/edit-image';
// import SongSelector from 'common/components/song-selector';

import EditImage from 'client/shared/components/edit-image/edit-image';
import SongUpload from 'client/shared/components/song-upload/song-upload';

import MZDList from '../manage-lists/mzdlist-list';

@inject('genreStore', 'formStore', 'playlistStore')//, 'songsStore'
@observer
class GenreModal extends Component {
	constructor (props) {
		super(props);

		this.state = {
			modalIsOpen: false
		};

		const { playlistStore } = this.props;
		playlistStore.fetchItems();
	}	

	render () {
		const {
			genreStore,
			buttonLabel = '',
			icon = 'pencil',
			buttonClassName = 'add-button button',
			title = 'Edit Genre'
		} = this.props;

		return (
			<div className="cell shrink">
				<ReactModal
					appElement={ window.document.querySelector('#app') }
					isOpen={ this.state.modalIsOpen }
					contentLabel="Edit Genre"
					shouldCloseOnOverlayClick={ true }
					className={{
						base: 'modal',
						afterOpen: 'modal-after-open',
						beforeClose: 'modal-beforex`-close'
					}}
					overlayClassName={{
						base: 'modal-sm-overlay',
						afterOpen: 'modal-sm-overlay-after-open',
						beforeClose: 'modal-sm-overlay-before-close'
					}}
				>
					<div data-ta="genreModal" style={{backgroundColor: '#00000000'}}>
						<div className="modal-title">{title}</div>
						<div className="grid-x">
							<div className="cell">
								{ this.renderMainContent() }
							</div>
						</div>
					</div>
					<div className="modal-sm-button-group">
						<button
							data-ta="saveGenreBtn"
							className="button neo login"
							onClick={ this.onClick }
						>
							Save
						</button>
						<button
							className="button neo"
							onClick={ this.handleCloseModal }
						>
							Close Modal
						</button>
					</div>
				</ReactModal>

				<button
					data-ta="genreModalBtn"
					className={ buttonClassName }
					onClick={ this.handleOpenModal }
				>
					<span className={ `fas fa-${icon} padding-0` }></span> { buttonLabel }
				</button>
			</div>
		);
	}

	getField () {
		const { genreStore: store, formStore } = this.props;
		const genre = this.getGenre();
		const { _id: dataId } = genre;

		return (props) => {
			const propsObj = { formStore, store };

			if (_.isEmpty(dataId) !== true) {

				Object.assign(propsObj, { dataId });
			}

			return (
				<FieldFactory { ...props } { ...propsObj } />
			);
		}
	}

	renderMainContent () {
		const { genreStore, formStore } = this.props;//, songsStore
		const genre = this.getGenre();
		const Field = this.getField();

		return (
			<div className="grid-x grid-padding-x">
				<div className="cell small-12" data-ta="genreLabelInputContainer">
					<Field fieldClass="large-field" fieldKey="genre.label" />
				</div>
			</div>
		);
	}

	getGenre () {
		const { genreStore } = this.props;
		const { genre = genreStore.data.genre.toPOJO() } = this.props;

		return genre;
	}

	@autobind
	onClick () {
		const { genreStore } = this.props;
		const playlist = this.getGenre();

		if (playlist._id) {

			genreStore.updateGenre(playlist);
			return;
		}

		genreStore.saveGenre(playlist);
	}

	@autobind
	handleOpenModal () {
		this.setState({
			modalIsOpen: true
		});
	}

	@autobind
	handleCloseModal () {
		this.setState({
			modalIsOpen: false
		});
	}

	@autobind
	handleImageCrop (imgData) {
		const { genreStore } = this.props;
		const { _id } = this.getGenre();

		if (_.isEmpty(_id)) {

			genreStore.data.genre.set('imgData', imgData);
			return;
		}

		genreStore.saveGenreArtwork({ _id, imgData }, {
			silent: true,
			onSuccess: this.handleCloseModal
		});
	}
}

export default GenreModal;
